import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { useAddressLabel } from '../../../hooks/use-address-label';
import { AddressInputWUT } from '../../../ui/address-input';
import { TextInputFieldWUT } from '../../../ui/text-input-field';
import { useAddressAutofill } from '../../multiline-address/multiline-address/address-autofill-context';
export const MlaAddressLineWUT = ({ autocomplete, ...rest })=>{
    const fieldType = FIELD_TYPES.MLA_ADDRESS_LINE;
    const { autocompleteEnabled } = useAddressAutofill();
    const label = useAddressLabel('addressLine1');
    return autocomplete || autocompleteEnabled ? /*#__PURE__*/ React.createElement(AddressInputWUT, {
        ...rest,
        fieldType: fieldType,
        label: label
    }) : /*#__PURE__*/ React.createElement(TextInputFieldWUT, {
        ...rest,
        fieldType: fieldType,
        label: label
    });
};

//# sourceMappingURL=mla-address-line-wut.js.map